import React from 'react';
/**
 * `DirectDebitTotalDisplay` renders the total payable amount for a direct debit
 * instalment plan.
 *
 * It calculates the total from first + subsequent instalments and formats the
 * result using the provided `culture` and current currency symbol.
 */

import { formatNumber } from '../../../common/Formatter';
import { useCurrencySymbol } from '../../../../hooks/useCurrencySymbol';
import { InstallmentPrice } from '../../../common/ProductMethods';
import { useTranslation } from 'react-i18next';
type DirectDebitTotalDisplayProps = {
  style: string;
  priceMonthly: InstallmentPrice;
  culture: string;
};

const DirectDebitTotalDisplay = ({
  style,
  priceMonthly,
  culture
}: DirectDebitTotalDisplayProps): JSX.Element => {
  const { t } = useTranslation();
  const totalPrefixText = t('renewals-quote.total-prefix-text');
  const currencySymbol = useCurrencySymbol();

  return (
    <p>
      <span>{totalPrefixText}</span>
      <span className={style}>
        {currencySymbol}
        {formatNumber(
          priceMonthly.firstInstallmentPrice +
            priceMonthly.subsequentInstallmentPrice *
              (priceMonthly.totalNumberOfInstallments - 1),
          2,
          culture
        )}
      </span>
    </p>
  );
};

export default DirectDebitTotalDisplay;
